import { useMutation } from 'react-query';
import { EindomfinansAPI } from '../api';

export const useSkattUpload = () => {
    return useMutation(EindomfinansAPI.uploadSkatt);
};
